import { Link } from "react-router-dom";
import routes from "@/app/routes";

const HomePage = () => {
  return (
    <div className="flex bg-[url('@/assets/image_2.png')] h-[calc(100vh-56px)] w-full bg-cover bg-center items-center justify-center text-white">
      <div className="relative flex flex-col items-center gap-4 max-w-5xl p-8 bg-[#102D6A]">
        <h1 className="text-2xl font-black tracking-tight leading-tight">
          Welcome to Portfolio Page (In Development)
        </h1>
        <p className="text-blue-200 text-base max-w-xl">
          Please navigate to the{" "}
          <Link
            to={routes.SOFT_TAG_MANAGER}
            className="underline hover:text-white transition-colors"
          >
            Self Service
          </Link>
        </p>
      </div>
    </div>
  );
};

export default HomePage;
